import { initializeRadar } from "./radar.js";
import { initializeAll } from "./all.js";

document.addEventListener("DOMContentLoaded", () => {
  initializeRadar();
  initializeAll();
});
